import { IResponseFilterReport04 } from 'app/api/report/model/report-04'
import R from 'app/assets/R'
import { BaseSelect, Option } from 'app/components/common/selects/BaseSelect'
import { usePagination } from 'app/hook'
import { useGetFilterReport04 } from 'app/react-query/hook/report'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const SelectServiceComponent = ({
  onChange,
}: {
  onChange?: (services?: string[]) => void
}) => {
  const { t } = useTranslation()

  const [services, setServices] = useState<string[] | undefined>([])
  const [isEdit, setIsEdit] = useState(false)
  const { data: dataBefore } = useGetFilterReport04()
  const { flattenDataList } = usePagination()
  const data: string[] = useMemo(() => {
    const res: IResponseFilterReport04 = flattenDataList(dataBefore)
    return res?.services ?? []
  }, [dataBefore])

  const onChangeService = (types: string[]) => {
    setServices(types)
    setIsEdit(true)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isEdit) {
        onChange?.(services)
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [services, isEdit])

  return (
    <SelectBaseStyled
      value={services}
      placeholder={t(R.strings.choose_service)}
      onChange={types => onChangeService(types as string[])}
      allowClear
      mode='multiple'
      maxTagCount={1}
    >
      {data?.map((itm, idx) => {
        return (
          <Option key={idx} value={itm}>
            {itm}
          </Option>
        )
      })}
    </SelectBaseStyled>
  )
}
export default SelectServiceComponent

const SelectBaseStyled = styled(BaseSelect)`
  .ant-select-arrow {
    top: 50%;
  }
`
